import createReducer from "@utils/createReducer";
import * as types from "../types/index";
import { logout } from "../../utils/api.config";

const initialState = {
  isLoading: false,
  data: [],
  holidayList: {},
  companyHolidayList: {},
  holidayAutofillList: {},
  newHoliday: {},
  error: null,
  succMsg: null,
  autofillMsg: null,
};

export const holidayReducer = createReducer(initialState, {
  [types.GET_HOLIDAYS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      newHoliday: null,
      succMsg: null,
      error: null,
    });
  },
  [types.GET_HOLIDAYS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      holidayList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HOLIDAYS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_COMPANY_HOLIDAYS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      companyHolidayList: null,
      succMsg: null,
      error: null,
    });
  },
  [types.GET_COMPANY_HOLIDAYS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      companyHolidayList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_COMPANY_HOLIDAYS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.ADD_COMPANY_HOLIDAYS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      succMsg: null,
      error: null,
    });
  },
  [types.ADD_COMPANY_HOLIDAYS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      newHoliday: action.payload,
      isLoading: false,
    });
  },
  [types.ADD_COMPANY_HOLIDAYS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.DELETE_COMPANY_HOLIDAY](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      newHoliday: null,
      succMsg: null,
      error: null,
    });
  },
  [types.DELETE_COMPANY_HOLIDAY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      succMsg: action.payload,
      error: null,
    });
  },
  [types.DELETE_COMPANY_HOLIDAY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      succMsg: null,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.PUT_COMPANY_HOLIDAY](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      newHoliday: null,
      error: null,
      succMsg: null,
    });
  },
  [types.PUT_COMPANY_HOLIDAY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      succMsg: action.payload,
      error: null,
    });
  },
  [types.PUT_COMPANY_HOLIDAY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      succMsg: null,
      error: action.payload,
      isLoading: false,
    });
  },

  [types.COPY_COMPANY_HOLIDAY](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      succMsg: null,
    });
  },
  [types.COPY_COMPANY_HOLIDAY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      succMsg: action.payload,
      error: null,
    });
  },
  [types.COPY_COMPANY_HOLIDAY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      succMsg: null,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HOLIDAY_AUTOFILL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      holidayAutofillList: null,
      succMsg: null,
      error: null,
    });
  },
  [types.GET_HOLIDAY_AUTOFILL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      holidayAutofillList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HOLIDAY_AUTOFILL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.ADD_HOLIDAY_AUTOFILL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      autofillMsg: null,
      error: null,
    });
  },
  [types.ADD_HOLIDAY_AUTOFILL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      autofillMsg: action.payload,
      isLoading: false,
    });
  },
  [types.ADD_HOLIDAY_AUTOFILL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      isLoading: false,
    });
  },

  [types.DELETE_HOLIDAY_AUTOFILL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      succMsg: null,
      error: null,
    });
  },
  [types.DELETE_HOLIDAY_AUTOFILL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      succMsg: action.payload,
      error: null,
    });
  },
  [types.DELETE_HOLIDAY_AUTOFILL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      succMsg: null,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.PUT_HOLIDAY_AUTOFILL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      autofillMsg: null,
    });
  },
  [types.PUT_HOLIDAY_AUTOFILL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      autofillMsg: action.payload,
      error: null,
    });
  },
  [types.PUT_HOLIDAY_AUTOFILL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      isLoading: false,
    });
  },
});
